import { Injectable, OnDestroy, signal } from '@angular/core';
import { Network } from '@capacitor/network';

@Injectable({ providedIn: 'root' })
export class NetworkStatusService implements OnDestroy {
  readonly isOnline = signal(true);

  private _listenerHandle?: { remove: () => Promise<void> };

  constructor() {
    this._init();
  }

  private async _init(): Promise<void> {
    const status = await Network.getStatus();
    this.isOnline.set(status.connected);

    this._listenerHandle = await Network.addListener('networkStatusChange', (s) => {
      this.isOnline.set(s.connected);
    });
  }

  async ngOnDestroy(): Promise<void> {
    await this._listenerHandle?.remove();
  }
}
